import HeaderBarDropdown from '@app/common/PageHeader/HeaderBarDropdown';
import { Nav } from '@app/common/PageHeader/HeaderNav/Nav';
import { useTrans } from 'base/utils/i18n';
import { IconArrow } from '@base/icon';
import styles from '@app/common/PageHeader/HeaderBar/index.module.less';

export const HeaderNav: React.FC = () => {
    const { t } = useTrans();
    return (
        <HeaderBarDropdown
            triggerProps={{
                type: 'text',
                content: (
                    <div className={'flex flex-middle'}>
                        {t('web_common_categories')}
                        <IconArrow direction={'down'} size={18} className={'ml-5'}/>
                    </div>
                ),
            }}
            menu={<Nav className={styles.nav}/>}
            overlayClassName={styles.overlay}
            placement="bottomLeft"
        />
    )
}
export default HeaderNav;